(() => {
  const root = document.querySelector('[data-ff-apple-catalog]');
  if (!root) return;

  const links = Array.from(root.querySelectorAll('[data-ff-jump]'));
  const groups = Array.from(root.querySelectorAll('[data-ff-group]'));
  const cards = Array.from(root.querySelectorAll('[data-ff-model]'));
  const subgroups = Array.from(root.querySelectorAll('.ff-apple-catalog__subgroup[id]'));
  const jump = root.querySelector('.ff-apple-catalog__jump-wrap');
  const browse = root.querySelector('.ff-apple-catalog__browse');
  if (!links.length || !groups.length) return;

  const setActiveGroup = (id) => {
    if (!id) return;
    links.forEach((link) => {
      link.classList.toggle('is-active', link.getAttribute('data-ff-jump') === id);
    });
  };

  const setActiveModel = (modelId) => {
    cards.forEach((card) => {
      const active = modelId && card.getAttribute('data-ff-model') === modelId;
      card.classList.toggle('is-active', active);
      const link = card.querySelector('[data-ff-model-link]');
      if (link) {
        if (active) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      }
    });

    if (!modelId) return;
    const activeCard = root.querySelector(`[data-ff-model="${modelId}"]`);
    if (!activeCard) return;
    const groupId = activeCard.getAttribute('data-ff-model-group');
    if (groupId) setActiveGroup(groupId);
  };

  const clearSubgroupHighlight = () => {
    subgroups.forEach((el) => el.classList.remove('is-hash-target'));
  };

  const resolveGroupId = (el) => {
    if (!el) return null;
    if (el.hasAttribute('data-ff-group')) return el.getAttribute('data-ff-group') || el.id;
    const group = el.closest('[data-ff-group]');
    return group ? group.getAttribute('data-ff-group') || group.id : null;
  };

  const syncStickyTop = () => {
    if (!jump || jump.classList.contains('is-unstuck')) return;
    const header = document.querySelector('.section-header');
    if (!header) return;
    const top = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    document.documentElement.style.setProperty('--ff-catalog-sticky-top', `${top}px`);
    const jumpHeight = Math.round(jump.getBoundingClientRect().height);
    const margin = `${top + jumpHeight + 8}px`;
    groups.forEach((group) => {
      group.style.scrollMarginTop = margin;
    });
    subgroups.forEach((sub) => {
      sub.style.scrollMarginTop = margin;
    });
    cards.forEach((card) => {
      card.style.scrollMarginTop = margin;
    });
  };

  const scrollToHashTarget = () => {
    const hash = window.location.hash.replace('#', '');
    if (!hash) {
      setActiveModel(null);
      clearSubgroupHighlight();
      return;
    }

    const el = document.getElementById(hash);
    if (!el || !root.contains(el)) {
      // Unknown hash — still try group jump ids.
      setActiveGroup(hash);
      return;
    }

    clearSubgroupHighlight();

    if (hash.startsWith('model-')) {
      setActiveModel(hash);
    } else {
      setActiveModel(null);
      const groupId = resolveGroupId(el);
      if (groupId) setActiveGroup(groupId);
      if (el.classList.contains('ff-apple-catalog__subgroup')) {
        el.classList.add('is-hash-target');
      }
    }

    syncStickyTop();
    requestAnimationFrame(() => {
      syncStickyTop();
      el.scrollIntoView({ block: 'start', behavior: 'auto' });
    });
  };

  const observer = new IntersectionObserver(
    (entries) => {
      const hash = window.location.hash.replace('#', '');
      // Keep hash-driven focus while landing on a model/subgroup.
      if (hash.startsWith('model-') || (hash && document.getElementById(hash)?.classList.contains('ff-apple-catalog__subgroup'))) {
        return;
      }
      const visible = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio);
      if (!visible.length) return;
      const id = visible[0].target.getAttribute('data-ff-group');
      if (id) setActiveGroup(id);
    },
    {
      root: null,
      rootMargin: '-30% 0px -55% 0px',
      threshold: [0.05, 0.2, 0.4],
    }
  );

  groups.forEach((group) => observer.observe(group));

  links.forEach((link) => {
    link.addEventListener('click', () => {
      const id = link.getAttribute('data-ff-jump');
      if (id) {
        setActiveModel(null);
        clearSubgroupHighlight();
        setActiveGroup(id);
      }
    });
  });

  cards.forEach((card) => {
    const link = card.querySelector('[data-ff-model-link]');
    if (!link) return;
    link.addEventListener('click', () => {
      const modelId = card.getAttribute('data-ff-model');
      setActiveModel(modelId);
      if (modelId && !link.getAttribute('href').startsWith('#')) {
        try {
          history.replaceState(null, '', `#${modelId}`);
        } catch (e) {}
      }
    });
  });

  window.addEventListener('hashchange', () => {
    scrollToHashTarget();
  });

  if (browse && jump) {
    const endSentinel = document.createElement('div');
    endSentinel.className = 'ff-apple-catalog__browse-end';
    endSentinel.setAttribute('aria-hidden', 'true');
    browse.appendChild(endSentinel);

    const endObserver = new IntersectionObserver(
      ([entry]) => {
        jump.classList.toggle('is-unstuck', entry.isIntersecting);
        if (!entry.isIntersecting) syncStickyTop();
      },
      { root: null, rootMargin: '0px 0px -85% 0px', threshold: 0 }
    );
    endObserver.observe(endSentinel);
  }

  syncStickyTop();
  window.addEventListener('scroll', syncStickyTop, { passive: true });
  window.addEventListener('resize', syncStickyTop);

  // Land on group / subgroup / model from mega-menu (or any deep link).
  scrollToHashTarget();
  // Re-run after sticky header/fonts settle.
  window.setTimeout(scrollToHashTarget, 120);
  window.setTimeout(scrollToHashTarget, 400);
})();
